
import ImageMeta from "@/mixins/imageMeta.js";

export default {
  name: "BlurHashResponsivePicture",
  mixins: [ImageMeta],
  props: {
    image: {
      type: Object,
      required: true
    },
   imgClass: {
      type: String,
      required: false,
      default: ''
    },
  },
  computed: {
    imageAttributes() {
      if (!this.image || !this.image.attributes) {
        return null;
      }
      return this.getAttribute(this.image, 'attributes');
    }
  },
  data() {
    return {
      imageLoaded: false,
      blurHashRemoved: false
    };
  },
  methods: {
    onImageLoaded() {
      this.imageLoaded = true;
      // Remove the BlurHashPicture after fade animation finished
      setTimeout(() => {
        this.blurHashRemoved = true;
      }, 500);
    }
  },
}
